import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { STRINGS } from '../../utils/strings';
import { secureStorageUtils } from '../../utils/secureStorageUtils';
import { SettingsResponse, UpdateUserSettingsRequest } from './interface';

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: STRINGS.API_URL,
    prepareHeaders: (headers) => {
      const token = secureStorageUtils.getItem('access-token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('accept', 'application/json');
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['BlockedUsers'],
  endpoints: (builder) => ({

   blockUser: builder.mutation<{ message: string }, { id: number; reason?: string }>({
      query: ({ id, reason }) => ({
        url: `/users/${id}/block`,
        method: 'POST',
        body: { id, reason },
      }),
      invalidatesTags: ['BlockedUsers'],
    }),

    unblockUser: builder.mutation<{ message: string }, number>({
      query: (id) => ({
        url: `/users/${id}/unblock`,
        method: 'POST',
      }),
      invalidatesTags: ['BlockedUsers'],
    }),

    getBlockedUsers: builder.query<
      { id: string; profile_picture: string | null; username: string }[],
      void
    >({
      query: () => ({
        url: '/users/blocked',
        method: 'GET',
      }),
      transformResponse: (response: { message: string; data: any[] }) => response.data,
      providesTags: ['BlockedUsers'],
      keepUnusedDataFor: 0,
    }),
    userUpdate: builder.mutation<SettingsResponse, UpdateUserSettingsRequest>({
      query: (body) => ({
        url: `/user/settings/update`,
        method: 'POST',
        body,
      }),
    }),

  }),
});

export const {
  useBlockUserMutation,
  useUnblockUserMutation,
  useGetBlockedUsersQuery,
  useUserUpdateMutation,
} = settingsApi;




